import React, { useEffect } from 'react'
import classes from './OutputPinCircle.module.css'
import outputRed from '../../../assets/stateIcons/output_red.png'
import outputGreen from '../../../assets/stateIcons/output_green.png'
import outputGrey from '../../../assets/stateIcons/pin_disabled.png'
import lockIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/lock_yellow.png'
import pulse from '../../../assets/stateIcons/pulse.png'
import App from '../../../App'

const OutputPinCircle = ({ OutputPins }) => {
    
    return (
        OutputPins.map((OutputPin, index) => {
            let OutputPinImage;
            console.log(OutputPin)

            if (OutputPin.hasLock){
                OutputPinImage = `url(${lockIcon})`;
            } else if (OutputPin.type == "PULSE" || OutputPin.type == "VIRTUAL_PULSE") {
                OutputPinImage = `url(${pulse})`
            } else {
                if (OutputPin.pinState === 0) {
                    OutputPinImage = `url(${outputGreen})`;
                } else if (OutputPin.pinState === 1) {
                    OutputPinImage = `url(${outputRed})`;
                } else if (OutputPin.pinState === 2) {
                    OutputPinImage = `url(${outputGrey})`;
                }
            }

            return (
                <li key={index}>
                    <div
                        className={classes.output}
                        style={{
                            backgroundImage: OutputPin.active ? OutputPinImage : `url(${outputGrey})`,
                            opacity: OutputPin.active ? 1.0 : 0.0,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundColor: !OutputPin.active ? "lightgrey" : "transparent" 
                        }}
                    />
                </li>
            )
        })
    );
}

export default OutputPinCircle;